$ = require 'jquery'
ActionListView = require 'app/scripts/views/action/action-list-view'
AddChecklistMenu = require 'app/scripts/views/checklist/add-checklist-menu'
Alerts = require 'app/scripts/views/lib/alerts'
{ Analytics } = require '@trello/atlassian-analytics'
AttachmentHelpers = require 'app/scripts/views/attachment/helpers'
AttachmentThumbView = require 'app/scripts/views/attachment/attachment-thumb-view'
AttachmentTypePickerView = require 'app/scripts/views/card/attachment-type-picker-view'
AttachmentViewer = require 'app/scripts/views/internal/attachment-viewer'
Auth = require 'app/scripts/db/auth'
AutoInsertionView = require 'app/scripts/views/internal/autocomplete/auto-insertion-view'
AutoMentionerView = require 'app/scripts/views/internal/autocomplete/auto-mentioner-view'
Browser = require '@trello/browser'
TrelloCompleterView = require 'app/scripts/views/internal/autocomplete/trello-completer-view'
CardAgingPopoverView = require 'app/scripts/views/card-aging/card-aging-popover-view.coffee'
CardCopyView = require 'app/scripts/views/card/card-copy-view'
{ toggleCardCoverChooserPopover } = require 'app/scripts/views/card/card-cover-chooser-popover.tsx'
CardDetailMoreMenuView = require 'app/scripts/views/card/card-detail-more-menu-view'
{ getFilteredActionsCount } = require 'app/scripts/views/card/card-detail-view-actions'
CardLabelSelectView = require 'app/scripts/views/label/card-label-select-view'
{ maybeDisplayLimitsErrorOnCardOpen } = require 'app/scripts/views/card/card-limits-error'
CardLocationView = require 'app/scripts/views/map/card-location-view'
CardMemberSelectView = require 'app/scripts/views/card/card-member-select-view'
CardMoveView = require 'app/scripts/views/card/card-move-view'
CardViewHelpers = require 'app/scripts/views/card/card-view-helpers'
ChecklistView = require 'app/scripts/views/checklist/checklist-view'
CompleterUtil = require 'app/scripts/views/internal/autocomplete/completer-util'
Confirm = require 'app/scripts/views/lib/confirm'
Controller = require 'app/scripts/controller'
CustomFieldCardDetailBadgesView = require 'app/scripts/views/custom-field/custom-field-card-detail-badges-view'
CustomFieldsButtonView = require 'app/scripts/views/custom-field/custom-fields-button-view'
DatePickerView = require 'app/scripts/views/card/date-picker-view'
Dates = require 'app/scripts/lib/dates'
DescriptionView = require 'app/scripts/views/description/description-view'
Dialog = require 'app/scripts/views/lib/dialog'
require 'app/scripts/views/internal/data-transfer/drag-drop-events'
DragSort = require 'app/scripts/views/lib/drag-sort'
DueDateHelpers = require 'app/scripts/views/internal/due-date-helpers'
EditableView = require 'app/scripts/views/internal/editable-view'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ Feedback } = require 'app/src/components/Feedback'
FormattingHelpView = require 'app/scripts/views/card/formatting-help-view'
Hearsay = require 'hearsay'
InProgressAttachmentView = require 'app/scripts/views/attachment/in-progress-attachment'
{ getKey, isForceSubmitEvent, Key, registerShortcutHandler, Scope, unregisterShortcutHandler, } = require '@trello/keybindings'
Label = require 'app/scripts/models/label'
LabelKeyHelper = require 'app/scripts/views/label/label-key-helper'
Layout = require 'app/scripts/views/lib/layout'
LegacyPowerUps = require 'app/scripts/data/legacy-power-ups'
LimitExceeded = require 'app/scripts/views/attachment/attachment-limit-exceeded-error'
MemberState = require 'app/scripts/view-models/member-state'
MembersVotedView = require 'app/scripts/views/member/members-voted-view'
ModelCache = require 'app/scripts/db/model-cache'
ModelLoader = require 'app/scripts/db/model-loader'
Monitor = require 'app/scripts/lib/monitor'
PasteInput = require 'app/scripts/views/internal/paste-input'
PluginCardButtonsView = require 'app/scripts/views/plugin/plugin-card-buttons-view'
PluginCardDetailBadgesView = require 'app/scripts/views/plugin/plugin-card-detail-badges-view'
PluginIOCache = require 'app/scripts/views/internal/plugins/plugin-io-cache'
PluginModelSerializer = require 'app/scripts/views/internal/plugins/plugin-model-serializer'
PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PluginSectionView = require 'app/scripts/views/plugin/plugin-section-view'
PluginCardBackSectionView = require 'app/scripts/views/plugin/plugin-card-back-section-view'
PopOver = require 'app/scripts/views/lib/pop-over'
PluginSuggestionPopOver = require 'app/scripts/views/plugin/plugin-suggestion-pop-over'
Promise = require 'bluebird'
SetCardLocationPopoverView = require 'app/scripts/views/map/set-card-location-popover-view'
StickerView = require 'app/scripts/views/stickers/sticker-view'
{ Storage } = require '@trello/storage'
TFM = require 'app/scripts/lib/markdown/tfm'
Tooltip = require 'app/scripts/views/lib/tooltip'
TrelloBoardAttachment = require 'app/scripts/views/attachment/trello-board-attachment'
TrelloCardAttachment = require 'app/scripts/views/attachment/trello-card-attachment'
{ UnsplashTracker } = require '@trello/unsplash'
Util = require 'app/scripts/lib/util'
UploadingLinkView = require 'app/scripts/views/card/uploading-link-view'
WindowSize = require 'app/scripts/lib/window-size'
_ = require 'underscore'
f = require 'effing'
friendlyLinks = require 'app/scripts/views/internal/friendly-links'
{ getSuggestionsFeedback } = require 'app/scripts/views/feedback/collectors/get-suggestions-feedback'
log = require 'app/scripts/debug/log'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
moment = require 'moment'
l = require 'app/scripts/lib/localize'
localizeCount = require 'app/scripts/lib/localize-count'
pastedFileName = require 'app/scripts/views/internal/pasted-file-name'
warnIfFileTooLarge = require 'app/scripts/views/internal/warn-if-file-too-large'
ninvoke = require 'app/scripts/lib/util/ninvoke'
cardDetailTemplate = require 'app/scripts/views/templates/card_detail'
cardDetailListTemplate = require 'app/scripts/views/templates/card_detail_list'
cardDetailAddButtonTemplate = require 'app/scripts/views/templates/card_detail_add_button'
cardDetailToggleButtonTemplate = require 'app/scripts/views/templates/card_detail_toggle_button'
labelTemplate = require 'app/scripts/views/templates/label'
editInProgressTemplate = require 'app/scripts/views/templates/edit_in_progress'
removeAllRanges = require 'app/scripts/lib/util/removeAllRanges'
parseTrelloUrl = require 'app/scripts/lib/util/url/parse-trello-url'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
pluginCoverWithDefaults = require 'app/scripts/lib/plugins/plugin-cover-with-defaults'
pluginValidators = require 'app/scripts/lib/plugins/plugin-validators'
TrelloClipboard = require 'app/scripts/lib/trello-clipboard'
{ toggleSuggestionsSettings } = require 'app/scripts/views/suggestions-settings/toggle-suggestions-settings'
{ Noun, Verb, track, trackUe, trackDebounced } = require '@trello/analytics'
{ animateRender, animateRemove } = require './animate-card'
{ getPotentialCovers } = require 'app/src/components/CardCoverChooser/SelectCover'
CARD_AGING_POWER_UP_ID = require('app/scripts/data/legacy-power-ups').cardAging
CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId
MAP_POWER_UP_ID = require('@trello/config').mapPowerUpId
{ renderComponent } = require 'app/src/components/ComponentWrapper'
{ DropboxSection, DropboxPluginId, DropboxClaimedHosts } = require 'app/src/components/DropboxSection'
{ sendPluginScreenEvent, sendPluginUIEvent } = require 'app/scripts/lib/plugins/plugin-behavioral-analytics'
React = require 'react'
{ CardBackBanner } = require 'app/src/components/CardBackBanner'
ReactDOM = require '@trello/react-dom-wrapper'
{ cardCoverColors } = require 'app/scripts/views/card/card-cover-colors'
{ trackSeparator } = require 'app/scripts/views/card/SeparatorCard/SeparatorCard'
{ shouldFireConfetti } = require 'app/scripts/views/card/should-fire-confetti'
confetti = require('canvas-confetti').default
{ Analytics } = require '@trello/atlassian-analytics'

attachmentAsMarkdown = (attachment) ->
  "[#{ attachment.get('name') }](#{ attachment.get('url') }) "

module.exports = mixin AutoInsertionView, CompleterUtil, CardViewHelpers, class CardDetailView extends EditableView
  className: 'card-detail-window u-clearfix'
  defaultActionLimit: 50
  maxActionLimit: 1000
  maximumCommentLength: 16384 # This is the most the API accepts for a string
  maxDescLength: 1800 # When to truncate the desc and show "Show full description."

  addListListener: ->
    # Archived lists may be loaded later so listening to @model.getList() won't
    # work until the data is loaded.

    # Clean up any old event listeners.

    idOldList = @model.previous('idList')

    if idOldList
      @stopListening(@modelCache, "add:List:#{ idOldList }")

      oldList = @modelCache.get('List', idOldList)
      @stopListening(oldList, 'change:closed')

    # Render list, add new listeners.

    handleList = =>
      @renderListDebounced()
      @renderArchivedDebounced()
      @renderDeleteDebounced()
      @listenTo @model.getList(),
        'change:closed': =>
          @renderArchivedDebounced()
          @renderDeleteDebounced()

    if @model.getList()
      handleList()
    else
      @listenToOnce @modelCache, "add:List:#{ @model.get('idList') }", handleList

    return

  initialize: ->
    super

    @makeDebouncedMethods 'render',
      'renderAddAttachments'
      'renderAddChecklists'
      'renderCover'
      'renderStickers'
      'renderName'
      'renderDescription'
      'renderArchived'
      'renderDelete'
      'renderLabels'
      'renderList'
      'renderVotes'
      'renderDueDate'
      'renderSubscribe'
      'renderAttachments'
      'renderMembers'
      'renderAging'
      'renderCustomFieldBadges'
      'renderPluginSections'
      'renderLocation'
      'renderCardTemplate'

    @listenTo @model,
      'change:name': @renderNameDebounced
      'change:closed': =>
        @renderArchivedDebounced()
        @renderDeleteDebounced()
      'change:isTemplate': =>
        @renderArchivedDebounced()
        @renderDeleteDebounced()
        @renderCardTemplateDebounced()
        @renderDueDateDebounced()
        @renderVotesDebounced()
      'change:labels': @renderLabelsDebounced
      'change:limits': =>
        @renderAddAttachmentsDebounced()
        @renderAddChecklistsDebounced()
      'change:idList': =>
        @renderListDebounced()
        @addListListener()
      'change:idMembersVoted': @renderVotesDebounced
      'change:due change:dueComplete': @renderDueDateDebounced
      'change:subscribed': @renderSubscribeDebounced
      'change:dateLastActivity': =>
        @renderAgingDebounced()
        @renderCoverDebounced()
        @renderPluginSectionsDebounced()
      'change:idAttachmentCover change:cover': ->
        @renderCoverDebounced()
      'destroy': @closeDialog
      'change:badges.votes': ->
        ModelLoader.loadCardVoters(@model.id).done()
      'change:coordinates': @renderLocationDebounced
      'change:idBoard': @closeDialog

    @addListListener()

    @listenTo @model.customFieldItemList, 'add remove reset change', =>
      @renderCustomFieldBadgesDebounced()

    @listenTo @model.labelList, 'add remove reset change', =>
      @renderLabelsDebounced()

    @listenTo @model.memberList,
      'add remove reset': @renderMembersDebounced

    @listenTo @model.memberList, 'change:initials change:avatarHash change:avatarSource change:fullName change:username': @renderMembersDebounced

    @listenTo @model.memberVotedList,
      'add remove reset': @renderVotesDebounced

    @listenTo @model.checklistList,
      'add reset': @renderChecklists
      'remove': @removeChecklist
      'sort': @sortChecklists

    @listenTo @model.attachmentList,
      'add remove reset sort': @renderAttachmentsDebounced

    @listenTo @model.stickerList,
      'add remove reset change sort': @renderStickersDebounced

    @listenTo @model.memberEditingList,
      'add remove reset change:action': @renderEditing

    board = @model.getBoard()
    @listenTo board,
      'change:labelNames': @renderLabelsDebounced
      'change:labels': @renderLabelsDebounced
      'change:limits': @renderAddChecklistsDebounced
      'change:prefs': (board) ->
        changed = (pref) ->
          board.get('prefs')?[pref] != board.previous('prefs')?[pref]
        # Try to be as specific as possible about what we rerender
        if changed('cardCovers')
          @renderCover()

        # Re-rendering the whole card will mess up in-progress edits, so don't
        # ever do that if there is an edit in progress
        requiresFullRender =
          changed('cardAging') || changed('comments') || changed('voting') || changed('isTemplate')
        if requiresFullRender && @$('.editing').length == 0
          @renderDebounced()

        if changed('hideVotes')
          @renderVotesDebounced()

    @listenTo board.customFieldList, 'add remove reset change', =>
      @renderCustomFieldBadgesDebounced()

    @listenTo board.boardPluginList, 'add remove reset change', =>
      @renderCustomFieldBadgesDebounced()
      @renderAgingDebounced()
      @renderLocationDebounced()

    # Some members might be in the card but not have made it to the board yet.
    # In that case, they won't be rendered, as being in a card but not its
    # board is considered an invalid state. When that is resolved - when the
    # member finally makes it to the board - rerender all members to get the
    # complete list.
    @listenTo board.memberList,
      'add remove reset': @renderMembersDebounced

    @listenTo MemberState, 'change:showSuggestions', =>
      @renderSuggestedActions()

    # subscribing to these continuous signals will fire once immediately
    # in this case we don't want that as it will be a duplicate call
    @subscribe pluginsChangedSignal(board, @model), _.after 2, =>
      @renderCoverDebounced()
      @renderAttachmentsDebounced()
      @renderPluginSectionsDebounced()
      @renderLocationDebounced()
      @renderAgingDebounced()

    @getData()

    @numAttachmentsProcessing = @slot(0)
    @watch 'numAttachmentsProcessing', _.after 2, =>
      @renderAttachmentsDebounced()

    @numTrelloAttachmentsProcessing = @slot(0)
    @watch 'numTrelloAttachmentsProcessing', _.after 2, =>
      @renderAttachmentsDebounced()

    # It's possible, if a card was just created, that it won't have the
    # desc specified yet
    @fHideFullDescription = @model.get('desc')?.length > @maxDescLength

    @actionListView = @collectionSubview ActionListView, @model.actionList,
      renderOpts:
        context: @model
        compact: false

    @markNotificationsReadOnActive()
    @listenTo Monitor, 'setStatus visibilitychange', @markNotificationsReadOnActive
    @listenTo ModelCache, 'add:Notification', (notification) =>
      if notification? && notification.get('data')?.card?.id == @model.id
        @markNotificationsReadOnActive()

    $(window).on "beforeunload.CardDetailView-#{@model.cid}", f(@, 'saveCommentDraft', true)

    @pluginThumbTrackCache = {}

    # Pre-set the clipboard to contain the card URL so if the user copies, the cards URL will
    # make it to their clipboard even if the user is directly navigating to a card route.
    TrelloClipboard.set(@model.getFullUrl())

    @listenTo Auth.me().boardList, 'add remove reset change:closed', @renderCopyCard

    @ATBDescComponentEnabled = featureFlagClient.get('publicproduct.atb_description_component', false)
    if @ATBDescComponentEnabled
      @descView = @subview DescriptionView, @model,
        maxDescLength: @maxDescLength
        card: @model
        board: @model.getBoard()
        placeholderKey: 'add-a-more-detailed-description'
    else
      @listenTo @model, 'change:desc': @renderDescriptionDebounced
      @listenTo Layout,
        'cancelEdits': @onCancelEdit
        'autosaveEdits': @onAutosaveDescription

    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @templateFlagEnabled = newVal
      @renderDebounced()

    registerShortcutHandler(@onShortcut, { scope: Scope.Dialog })
    PasteInput.addHandler(@, { scope: 'dialog' })

    @colorCoversFlagEnabled =
      featureFlagClient.get('remarkable.color-covers', false)

    @cardTemplatesFlagEnabled = featureFlagClient.get('remarkable.card-templates', false)

    @confettiEnabled = featureFlagClient.get('remarkable.confetti', false)
    featureFlagClient.on 'remarkable.confetti', (newVal) =>
      @confettiEnabled = newVal

    @sendGASEvent = featureFlagClient.get('dataeng.gasv3-event-tracking', false)

    ################################
    # START - Card back transition #
    ################################

    if (featureFlagClient.get('animations'))
      animateRender(this)

    ################################
    # END - Card back transition   #
    ################################


  remove: ->
    @saveCommentDraft(true)
    $(window).off ".CardDetailView-#{@model.cid}"
    unregisterShortcutHandler(@onShortcut)
    PasteInput.removeHandler(@)

    ################################
    # START - Card back transition #
    ################################
    if (featureFlagClient.get('animations'))
      animateRemove(this)
    ################################
    # END - Card back transition   #
    ################################

    if @cardTemplatesFlagEnabled
      @removeBanner()

    super
    return

  markNotificationsReadOnActive: ->
    if Monitor.getStatus() == 'active' || !Monitor.getHidden()
      @markRelatedNotificationsRead()

  markRelatedNotificationsRead: ->
    relatedNotifications = @modelCache.all('Notification')
      .filter((notification) => notification.get('data')?.card?.id == @model.id)
    if relatedNotifications.length > 0
      unreadNotifications = relatedNotifications.filter((notification) -> notification.get('unread'))
      if unreadNotifications.length > 0
        # mark as read to update the UI
        # server update is handled via markAssociatedNotificationsRead
        unreadNotifications.forEach((notification) -> notification.set({ unread: false }))
      else
        # Return early, we know all related notifications are already marked as read
        return

    @model.markAssociatedNotificationsRead()

  isOnBoardTemplate: ->
    @templateFlagEnabled && @model.isOnBoardTemplate()

  events:
    # sidebar
    'click .js-edit-labels': 'editLabelsSidebar'
    'click .js-change-card-members': 'changeMembersSidebar'
    'click .js-add-checklist-menu': 'onChecklistClick'
    'click .js-add-due-date': 'dueDateSidebar'
    'click .js-card-cover-chooser': 'cardCoverChooserSidebar'
    'click .js-attach': 'openAttachPicker'
    'click .js-attach-trello-attachment': 'openAttachTrelloPicker'
    'click .js-join': 'join'
    'click .js-suggested-actions-settings': toggleSuggestionsSettings('Card Detail')
    'click .js-suggested-actions-feedback': getSuggestionsFeedback({ placement: 'Card Detail' })

    'click .js-edit-fields': 'editFieldsSidebar'
    'click .js-edit-location': 'editLocationSidebar'
    'click .js-card-aging-card-button': 'cardAgingSidebar'

    'click .js-move-card': 'moveCard'
    'click .js-copy-card': 'copyCard'
    'click .js-subscribe': 'subscribeToCard'
    'click .js-unsubscribe': 'unsubscribeFromCard'
    'click .js-vote': 'vote'
    'click .js-unvote': 'unvote'
    'click .js-convert-to-template': 'convertToTemplate'
    'click .js-convert-to-card': 'convertToCard'

    'click .js-archive-card': 'archiveCard'
    'click .js-unarchive-card': 'unarchiveCard'
    'click .js-delete-card': 'deleteCardSidebar'

    'click .js-more-menu': 'showMoreMenu'

    # title
    'keydown  .js-card-detail-title-input': 'nameKeyDownEvent'
    'focus    .js-card-detail-title-input': (e) ->
      @startNameEditing({ focus: false })

    'blur     .js-card-detail-title-input': 'saveNameEditing'

    # main col
    'click .js-remove-cover': 'removeCover'
    'click .js-open-card-cover-in-viewer': 'openCoverInViewer'
    'click .js-open-move-from-header': 'openMoveFromHeader'
    'click .js-details-edit-members': 'editMembersMain'
    'click .js-details-edit-labels': 'editLabelsMain'
    'click .js-edit-label .card-label': 'editLabelsMainSingleLabel'
    'click .js-details-edit-due-date': 'showDueDateBadgeMenu'
    'click .js-details-toggle-due-date-complete': 'toggleDueDateComplete'
    'click .js-show-votes': 'showVotes'
    'click .js-member-on-card-menu': 'openMemberOnCardMenu'

    # description
    'click .js-edit-desc': 'editDesc'
    'click .js-desc-content.is-hide-full': 'showFullDescription'
    'click .js-format-help': 'openFormatHelp'
    'keyup .js-description-draft': 'keyAutoMention'

    'click .js-view-some-attachments': 'showFewerAttachments'
    'click .js-view-all-attachments': 'showMoreAttachments'
    'click .js-view-some-trello-attachments': 'showFewerTrelloAttachments'
    'click .js-view-all-trello-attachments': 'showMoreTrelloAttachments'
    'click .js-show-all-actions': 'showAllActions'

    # comments
    'keydown .js-new-comment-input': 'keydownCommentEvent'
    'input .js-new-comment-input': 'commentInputEvent'
    'mutated .js-new-comment-input': 'commentInputEvent'
    'click .js-add-comment:not(:disabled)': 'submitComment'
    'click .js-comment-subscribe': 'subscribeOnComment'
    'click .js-attach-comment': 'attachComment'
    'click .js-truncate-comment': 'truncateComment'
    'click .js-new-comment': 'inputComment'
    'focus .js-new-comment-input': 'inputComment'
    'keyup .js-new-comment-input': 'keyAutoMention'
    'click': 'clickAwayFromComment'

    'click .js-new-comment .js-comment-add-attachment': 'commentAddAttachment'
    'click .js-new-comment .js-comment-mention-member': 'commentMentionMember'
    'click .js-new-comment .js-comment-add-emoji': 'commentAddEmoji'
    'click .js-new-comment .js-comment-add-card': 'commentAddCard'

    'click .js-show-details': 'showDetails'
    'click .js-hide-details': 'hideDetails'

    'click a[href]': 'interceptHighlightLink'

    # attachments
    'dd-enter:files': 'dragenter'
    'dd-leave:files': 'dragleave'
    'dd-drop:files': 'dropFiles'
    'dd-enter:url': 'dragenter'
    'dd-leave:url': 'dragleave'
    'dd-drop:url': 'dropUrl'
    'pasteinput:files': 'dropFiles'
    'pasteinput:url': 'dropUrl'

    # checklist sort
    'sortstop .js-checklist-list': 'sortStop'

    'sortstop .js-attachment-list': 'sortStopAttachments'

    'replyToAction': 'replyToAction'
    'replyToAllAction': 'replyToAllAction'

    # Watch via comment tooltip
    'mouseenter .js-comment-subscribe': (e) ->
      $el = @$(e.currentTarget)
      Tooltip.show($el.attr('aria-label'), $el, false, Tooltip.STYLE.MENU)

    'mouseleave .js-comment-subscribe': (e) ->
      Tooltip.hide()

  onShortcut: (event) =>
    board = @model.getBoard()
    editable = @model.editable()
    isTemplate = @cardTemplatesFlagEnabled && !!@model.get('isTemplate')
    loggedIn = Auth.isLoggedIn()
    isOnBoardTemplate = @isOnBoardTemplate()
    key = getKey(event)

    switch key
      when Key.Space
        if editable && !isOnBoardTemplate && (board.hasActiveMembership(Auth.me()) || board.isEditableByTeamMemberAndIsNotABoardMember())
          # TODO: requestJoinBoard unecessary once WLRS-495 ships
          toggleMemberFn = => @model.toggleMember(Auth.myId())
          board.requestJoinBoard(toggleMemberFn)
          event.preventDefault()
          track 'Keyboard Shortcuts', 'Space - Toggle Assigning Self', 'Card Detail'

      when Key.a, Key.m
        if editable && !isOnBoardTemplate
          @changeMembersSidebar()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'A - Assign Members', 'Card Detail'

      when Key.e
        if editable
          @editDesc()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'E - Edit Description', 'Card Detail'

      when Key.l
        if editable
          @_openEditLabelsSidebar({ hideOnSelect: false })
          event.preventDefault()
          track 'Keyboard Shortcuts', 'L - Edit Labels', 'Card Detail'

      when Key.d
        if editable && !isTemplate
          if @model.get('due')?
            @showDueDateBadgeMenu()
          else
            @dueDateSidebar()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'D - Due Dates', 'Card Detail'

      when Key.Dash
        if editable
          @onChecklistShortcut()
          event.preventDefault()
          track 'Keyboard Shortcuts', '- - Add Checklist'

      when Key.c
        if editable
          @archiveCard()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'C - Archive Card'

      when Key.t
        if editable
          @editTitle()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'T - Edit Title'

      when Key.AngleRight, Key.Period
        if editable
          @model.moveToNextList(if key == Key.AngleRight then 'top' else 'bottom')
          event.preventDefault()
          track 'Keyboard Shortcuts', '> - Move to Next List'

      when Key.AngleLeft, Key.Comma
        if editable
          @model.moveToPrevList(if key == Key.AngleLeft then 'top' else 'bottom')
          event.preventDefault()
          track 'Keyboard Shortcuts', '< - Move to Previous List'

      when Key.Zero, Key.One, Key.Two, Key.Three, Key.Four, \
           Key.Five, Key.Six, Key.Seven, Key.Eight, Key.Nine
        if editable
          fxNoUniqueLabel = (color) =>
            @_openEditLabelsSidebar({ searchInit: color, hideOnSelect: true })
          LabelKeyHelper.setLabelFromKey(key, @model, fxNoUniqueLabel)
          event.preventDefault()
          track 'Keyboard Shortcuts', '0-9 - Toggle Specific Label'

      when Key.v
        if !isTemplate && board.canVote(Auth.me())
          @model.toggleVote()
          event.preventDefault()
          track 'Keyboard Shortcuts', 'V - Vote'

      when Key.s
        if loggedIn && !isOnBoardTemplate
          subscribed = @model.get('subscribed')
          @model.subscribe(!subscribed)
          event.preventDefault()
          track 'Keyboard Shortcuts', 'S - Subscribe', if subscribed then "Unsubscribe" else "Subscribe"

      when Key.j
        if (nextCard = @model.nextCard())?
          Controller.showCardDetail(nextCard, { isNavigating: true })
          event.preventDefault()
          track 'Keyboard Shortcuts', 'J - Down'

      when Key.k
        if (prevCard = @model.prevCard())?
          Controller.showCardDetail(prevCard, { isNavigating: true })
          event.preventDefault()
          track 'Keyboard Shortcuts', 'K - Up'

  incrementNumAttachmentsProcessing: (count = 1) ->
    @numAttachmentsProcessing.update f.add(count)

  decrementNumAttachmentsProcessing: (count = 1) ->
    @numAttachmentsProcessing.update f.sub(count)

  incrementNumTrelloAttachmentsProcessing: (count = 1) ->
    @numTrelloAttachmentsProcessing.update f.add(count)

  decrementNumTrelloAttachmentsProcessing: (count = 1) ->
    @numTrelloAttachmentsProcessing.update f.sub(count)

  getData: ->
    @loading = true
    @$('.js-loading-card-actions').show()

    @waitForId @model, =>
      limit = if @fShowAllActions then @maxActionLimit else @defaultActionLimit
      Promise.try =>
        if !Auth.isLoggedIn() || Auth.me().getShowDetails()
          ModelLoader.loadCardDetails @model.id, limit
        else
          ModelLoader.loadCardHideDetails @model.id, limit
      .finally =>
        @loading = false
        @$('.js-loading-card-actions').hide()
      .then =>
        @renderShowAllActionsButton()
        @scrollToHighlight()
      .done()

    return

  scrollToHighlight: ->
    lastScroll = Date.now()

    cancelAnimationFrame(@scrollInterval)
    snapTo = null

    updateScroll = =>
      if Dialog.scrolledSince(lastScroll)
        return

      if (el = @$('.mod-highlighted')[0])?
        if !snapTo
          rect = el.getBoundingClientRect()
          if rect.top < 0
            snapTo = 'top'
          else if rect.top + rect.height > window.innerHeight
            snapTo = 'bottom'
          else
            snapTo = null


        if snapTo == 'top'
          el.scrollIntoView(true)
        else if snapTo == 'bottom'
          el.scrollIntoView(false)

        lastScroll = Date.now()

      @scrollInterval = @requestAnimationFrame(updateScroll)
      return

    updateScroll()
    return

  render: ->
    @fShowAllAttachments = false
    @fShowAllTrelloAttachments = false
    @fShowAllActions = false

    data = _.extend @model.toJSON(),
      canComment: @model.getBoard().canComment(Auth.me()) && !@isOnBoardTemplate()
      isLoggedIn: Auth.isLoggedIn()
      canToggleDetails: Auth.isLoggedIn()
      hasAttachments: @model.attachmentList.length > 0
      me: Auth.me().toJSON()
      loading: @loading
      editable: @model.editable()
      subscribeOnComment: Auth.me().isSubscribeOnCommentEnabled()
      ATBDescComponentEnabled: @ATBDescComponentEnabled
      isOnBoardTemplate: @isOnBoardTemplate()
      isSubscribed: @model.get('subscribed') || @model.get('badges')?.subscribed
      hideVotes: !!@model.getBoard().get('prefs')?.hideVotes
      viewingMemberVoted: @model.get('badges')?.viewingMemberVoted
      cardCoverChooserEnabled: @model.getBoard().getPref('cardCovers')
      cardCoverIsAttachment: @model.hasAttachmentCover()
      cardTemplatesFlagEnabled: @cardTemplatesFlagEnabled
      isTemplate: !!@model.get('isTemplate')

    @$el.html cardDetailTemplate(data)

    @actionListView.setElement @$('.js-list-actions')[0]

    @commentInput = @$('.js-new-comment-input')[0]

    @renderCover()
    .renderStickers()
    .renderName()
    .renderList()
    .renderActionList()
    .renderShowAllActionsButton()
    .renderMembers()
    .renderSuggestedActions()
    .renderArchived()
    .renderDelete()
    .renderChecklists()
    .renderCardTemplate()
    .renderSubscribe()
    .renderVotes()
    .renderDueDate()
    .renderAttachments()
    .renderLocation()
    .renderPluginSections()
    .renderAddAttachments()
    .renderAddChecklists()
    .renderLabels()
    .renderAging()
    .renderEditing()
    .renderCustomFieldBadges()
    .renderPluginBadges()
    .renderPluginButtons()
    .renderBanner()
    .renderCopyCard()

    if @ATBDescComponentEnabled
      @appendSubview @descView, @$('.js-fill-card-detail-desc')
    else
      @renderDescription()

    if data.canComment
      @recallDrafts()

    _.defer =>
      @$('.js-card-detail-title-input').autosize(append: false)
      @$('.js-new-comment-input').autosize(append: false)
      @renderCommentControls()

    # So, Chrome appears to have a crazy rendering bug that makes the
    # card detail appear to randomly jump to different scroll positions.  It
    # isn't clear exactly what's causing this issue, but bug reports like
    # https://bugs.chromium.org/p/chromium/issues/detail?id=581875
    # seem to indicate that position: fixed elements don't play nicely with
    # recent changes to how chrome does scrolling
    if Browser.browserStr !in ['chrome']
      @defer _.bind(@fixSidebar, @)

    Dates.update(@el)

    @

  _commentDraftKey: -> "draft_#{@model.id}_comment"

  recallDrafts: ->
    commentDraftText = Storage.get @_commentDraftKey()
    if commentDraftText
      @$('.js-new-comment-input').val(commentDraftText)
    @renderCommentSubmitAbility()
    super

  onAutosaveDescription: ($target) ->
    @commitEdits(null, $target)

  onCancelEdit: ->
    @saveCommentDraft()
    @renderDescriptionDebounced()

  saveCommentDraft: (didCloseCard = false) ->
    $input = @$('.js-new-comment-input')
    if $input.length == 0
      return
    commentText = $input.val()
    if commentText
      Storage.set @_commentDraftKey(), commentText
      if didCloseCard
        track('Card Detail', 'Comment', 'Save Comment Draft', @model.trackProperty())
        trackUe('Card Detail', 'save', 'comment draft', '', '', 'when closing a card', '')
    else
      Storage.unset @_commentDraftKey()
    return

  saveCardName: ->
    $input = @$('.js-card-detail-title-input')
    newValue = $input.val()
    name = @model.get('name')

    # remove whitespace
    newValue = newValue.replace(/\s+/g, ' ').trim()

    # if it's the same name, don't save
    if newValue == name
      return

    # if it's too long, don't save
    if newValue.length > 16384
      return

    # can't be empty.
    if newValue.trim().length == 0
      return

    # We should handle the returned `err` someday…
    @model.update 'name', newValue

    trackSeparator(newValue, {
      category: 'card detail'
      method: 'by editing name'
    })

    return

  nameKeyDownEvent: (e) ->

    if getKey(e) == Key.Enter
      Util.stop(e) # prevents new lines
      @saveNameEditing()

    if getKey(e) == Key.Escape
      Util.stop(e) # don't close the overlay…
      @cancelNameEditing()

    return

  startNameEditing: (options = {}) ->
    $input = @$('.js-card-detail-title-input')

    if !$input.hasClass('is-editing')
      $input.addClass('is-editing')

      if options.focus
        $input.focus().select()

    return

  saveNameEditing: ->
    $input = @$('.js-card-detail-title-input')
    if $input.hasClass('is-editing')
      @stopNameEditing()
      @saveCardName()

  cancelNameEditing: ->
    @stopNameEditing()
    @renderName()

  stopNameEditing: ->
    $input = @$('.js-card-detail-title-input')
    if $input.hasClass('is-editing') && $input.val().trim()
      $input.removeClass('is-editing')
      # We previously only blurred the $input if it looked like it had focus,
      # but this was problematic.
      #
      # If you switch tabs in Chrome by clicking on another tab and then come
      # back to this window, jquery will fire a `focusout` event, and we'd
      # end up in a state where the input still looked active even though
      # the edit had finished.
      $input.blur()
      removeAllRanges()

    return

  setRelativeSidebarPos: ->
    @fFixed = false
    @fRelative = true

    @$('.window-sidebar').css
      left: ''
      top: ''
      position: 'relative'

  setFixedSidebarLeftPos: ->
    if @fFixed
      winLeft = parseFloat($('.window').offset().left)
      left = winLeft + $('.window').width() - @$('.window-sidebar').outerWidth()

      @$('.window-sidebar').css { left }

  setFixedSidebarPos: ->
    @fFixed = true
    @fRelative = false

    @setFixedSidebarLeftPos()

    @$('.window-sidebar').css
      top: 0
      position: 'fixed'

  fixSidebar: ->
    $overlay = $('.window-overlay').off('scroll.fixSidebar')

    @fFixed = false
    @fRelative = false

    m = parseInt $('.window').css('margin-top')
    s = parseInt @$('.window-sidebar').css('padding-top')

    updateSidebarPos = =>
      h = @$('.window-header').outerHeight()
      c = @$('.window-cover:visible').outerHeight() ? 0
      a = @$('.window-archive-banner:visible').outerHeight() ? 0

      sidebarScrollTop = m + h + c + a + s

      # Don't fix the sidebar if the window is shorter than it (you need to be
      # able to scroll to get at the bottom of the sidebar)
      if (($overlay.scrollTop() <= sidebarScrollTop) ||
          WindowSize.fSmall ||
          @$('.window-sidebar').height() > $(window).height())
        if !@fRelative
          @setRelativeSidebarPos()
          return

      else
        if !@fFixed
          @setFixedSidebarPos()
          return

    throttledUpdateSidebarPos = @throttle updateSidebarPos, 32

    $overlay.on 'scroll.fixSidebar', throttledUpdateSidebarPos

    return

  editDesc: (e) ->
    Util.stop(e)
    @showFullDescription()
    @edit('desc')
    return

  expandDesc: (e) ->
    Util.stop(e)
    @showFullDescription()
    @edit('desc', false)
    return

  showFullDescription: (e) ->
    @fHideFullDescription = false
    $('.js-desc-content').removeClass('is-hide-full')
    return

  editTitle: (e) ->
    @startNameEditing({ focus: true })
    return

  archiveCard: (e) ->
    @model.close()
    track("Card Detail", "Sidebar", "Archive Button", @model.trackProperty())
    return

  unarchiveCard: (e) ->
    options = {
      $elem: $(e.target),
      hasAttachments: @model.attachmentList.length > 0,
      destinationBoard: @model.getBoard(),
      destinationList: @model.getList(),
    }
    if maybeDisplayLimitsErrorOnCardOpen(options)
      return

    track("Card Detail", "Sidebar", "Re-Open Button", @model.trackProperty())
    @model.reopen()
    return

  deleteCardSidebar: (e) ->
    Confirm.toggle 'delete card',
      elem: e.target
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        Dialog.hide()
        @model.destroy()
        track("Card", "Delete", undefined, @model.trackProperty())

    track("Card Detail", "Sidebar", "Open Delete Confirm", @model.trackProperty())
    return

  showMoreMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-more-menu')
      view: CardDetailMoreMenuView
      options: { @model, @modelCache }

    trackUe(
      "card sidebar", "opens", "share and more menu", "", "", 'by clicking share button',
      { cardid: @model.id, boardid: @model.getBoard().id }
    )
    return

  openCoverInViewer: (e) ->
    Util.stop(e)
    if !@showCover()
      return

    coverModel = @model.attachmentList.get(@model.get('idAttachmentCover'))
    if !AttachmentViewer.isActive()
      AttachmentViewer.show
        model: @model
        attachmentModel: coverModel
      track("Card Detail", "Open Attachment Viewer via Cover", coverModel.getType(), @model.trackProperty())
    return

  # move
  openMoveMenu: (elem) ->
    PopOver.toggle
      elem: elem
      view: CardMoveView
      options: { @model, @modelCache }

    return

  openMoveFromHeader: (e) ->
    Util.stop(e)
    @openMoveMenu(@$('.js-open-move-from-header'), 20)
    track("Card Detail", "Move Button (via Header)", undefined, @model.trackProperty())
    return

  moveCard: (e) ->
    Util.stop(e)
    @openMoveMenu(@$('.js-move-card'), 35)
    track("Card Detail", "Sidebar", "Open Move Menu", @model.trackProperty())
    return

  copyCard: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-copy-card')
      view: CardCopyView
      options: { @model, @modelCache }

    track("Card Detail", "Sidebar", "Open Copy Menu", @model.trackProperty())
    return

  # labels
  openLabelsPopOver: (elem, options) ->
    PopOver.toggle
      elem: elem
      view: CardLabelSelectView
      options: _.extend({ @model, @modelCache }, options)
    return

  editLabelsMainSingleLabel: (e) ->
    Util.stop(e)
    @openLabelsPopOver(@$(e.target).closest('.card-label'))
    track("Card Detail", "Edit Labels Main Column - Single Label", undefined, @model.trackProperty())
    return

  editLabelsMain: (e) ->
    Util.stop(e)
    @openLabelsPopOver(@$('.js-details-edit-labels'))
    track("Card Detail", "Edit Labels Main Column - Plus Button", undefined, @model.trackProperty())
    return

  editLabelsSidebar: (e) ->
    Util.stop(e)
    track("Card Detail", "Sidebar", "Edit Labels Button", @model.trackProperty())
    @_openEditLabelsSidebar()

  _openEditLabelsSidebar: (options) ->
    @openLabelsPopOver(@$('.js-edit-labels'), options)

  showVotes: (e) ->
    Util.stop(e)
    PopOver.toggle
      elem: @$('.js-show-votes')
      view: MembersVotedView
      options: { @model, @modelCache }

    track("Card Detail", "Header Vote Button", undefined, @model.trackProperty())
    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-detail-badge', LegacyPowerUps.voting)
    sendPluginUIEvent(LegacyPowerUps.voting, {
      action: 'clicked'
      actionSubject: 'badge'
      source: 'cardDetailScreen'
      actionSubjectId: 'cardDetailBadge'
      objectType: 'powerUp'
      objectId: LegacyPowerUps.voting
    })

    return

  removeCover: (e) ->
    Util.stop(e)
    @model.removeCover(null)
    track("Card Detail", "Card Cover", "Remove Cover", @model.trackProperty())
    return

  showCover: ->
    @model.getBoard().getPref('cardCovers') && @model.hasCover()

  checkShowCover: ->
    hasCover = @showCover() || @hasPluginCover
    hasStickers = @model.hasStickers()

    if hasCover
      @$('.js-card-cover-box')
        .removeClass('hide window-cover-stickers-only')
        .addClass('is-covered')
        .toggleClass('has-attachment-cover', @model.hasAttachmentCover())
    else if hasStickers
      @$('.js-card-cover-box')
      .removeClass('hide is-covered')
      .addClass('window-cover-stickers-only')
    else
      @$('.js-card-cover-box').addClass('hide')

    return

  clearCover: ->
    @$('.js-card-cover-box').css
      'background-color': ''
      'background-image': ''
      'height': ''
      'padding': ''

    btnClasses = [
      'dialog-close-button-light'
      'dialog-close-button-dark'
    ]

    $('.dialog-close-button').removeClass(btnClasses.join(' '))
    @$('.window-sidebar').find('.js-card-cover-chooser').removeClass('hide')

  renderAddAttachments: ->
    disabled = !@model.canAttach()
    @$('.js-attach,.js-attach-trello-attachment,.js-attach-link')
      .toggleClass('disabled', disabled)

    @

  renderAddChecklists: ->
    cardOver = @model.isOverLimit('checklists', 'perCard')
    boardOver = @model.getBoard().isOverLimit('checklists', 'perBoard')
    disabled = cardOver || boardOver

    @$('.js-add-checklist-menu').toggleClass('disabled', disabled)

    @

  renderCover: ->
    @clearCover()

    hasCoverMenu = @model.editable()
    canHaveCover = @model.getBoard().getPref('cardCovers')
    showHeaderCoverChooser = @showCover() && hasCoverMenu
    showSidebarChooser = !showHeaderCoverChooser && canHaveCover && hasCoverMenu

    applyCover = ({ url, height, size, edgeColor, color, brightness, position, padding }) =>
      position ?= 'center'
      padding ?= '0'
      brightness ?=
        if edgeColor && edgeColor != 'transparent'
          [r, g, b] = edgeColor.match(/[0-9a-f]{2}/ig).map (v) -> parseInt(v, 16)

          avg = (r + g + b) / 3
          if avg >= 140
            'light'
          else if avg < 140
            'dark'

      $cardCoverBox = @$('.js-card-cover-box')
      # This button isn't contained in the view, but we're trying to control the style
      # anyway
      $closeButton = $('.dialog-close-button')

      $cardCoverBox.removeClass('card-cover-dark card-cover-light')
      $closeButton.removeClass('dialog-close-button-dark dialog-close-button-light dialog-close-button-indeterminate')

      if color
        backgroundColor = cardCoverColors[color]
      else
        backgroundColor = edgeColor ? 'transparent'

      $cardCoverBox.css('background-color', backgroundColor)

      btnClass =
        switch brightness
          when 'light' then 'dark'
          when 'dark' then 'light'
          else 'indeterminate'

      if btnClass?
        $closeButton.addClass("dialog-close-button-#{btnClass}")
        $cardCoverBox.addClass("card-cover-#{brightness}")

      $cardCoverBox
        .css
          'background-image': if url then "url(\"#{url}\")" else ''
          'height': height
          'background-size': size
          'background-origin': 'content-box'
          'padding': padding
          'box-sizing': 'border-box'
          'background-position': position


        $cardCoverBox.find('.window-cover-menu').toggleClass('hide', !showHeaderCoverChooser)
        @$('.window-sidebar').find('.js-card-cover-chooser').toggleClass('hide', !showSidebarChooser)


    if @showCover()
      cover = @model.get('cover')

      { previews, edgeColor, color, brightness } =
        if cover?.color
          { color: cover.color }
        else if cover?.idAttachment || cover?.idUploadedBackground
          {
            previews: cover.scaled
            edgeColor: cover.edgeColor
            # NOTE: the card cover brightness isn't getting set so we're always
            # getting back the default 'light'.  Once that's fixed we can use
            # the cover brightness instead of calculating it from the edgeColor.
            #brightness: cover.brightness
          }
        else
          {}

      if hasCoverMenu
        MIN_HEIGHT = 116
      else
        MIN_HEIGHT = 48

      MAX_HEIGHT = 160
      MAX_WIDTH = 730

      if (color? && @colorCoversFlagEnabled) || previews?
        @hasPluginCover = false
        if Browser.isHighDPI()
          maxWidth = MAX_WIDTH * 2
          maxHeight = MAX_HEIGHT * 2
        else
          maxWidth = MAX_WIDTH
          maxHeight = MAX_HEIGHT

        # Find the smallest preview that has a height that exceeds the maximum
        # height we'll give to a card cover, and doesn't exceed the width of a
        # card.
        preview = Util.smallestPreviewBetween(previews, 0, maxHeight, maxWidth, Infinity) ?
          Util.biggestPreview(previews)

        if color
          height = MIN_HEIGHT
          size = 'initial'
        else
          if preview?
            coverImgUrl = preview.url
          else
            # NOTE: This fallback is unsuitable if we're showing previews for things that
            # aren't image attachments
            coverImgUrl = attachmentCover.get('url')

          height = Math.max(MIN_HEIGHT, Math.min(preview?.height ? MAX_HEIGHT, MAX_HEIGHT))
          size = if preview?.height < height then 'initial' else 'contain'

        applyCover({ url: coverImgUrl, height, size, edgeColor, color, brightness })

        if cover?.idUploadedBackground
          UnsplashTracker.trackOncePerInterval(cover.sharedSourceUrl)

    else if @model.getBoard().getPref('cardCovers')
      PluginRunner.one
        command: 'card-cover'
        board: @model.getBoard()
        card: @model
        list: @model.getList()
        timeout: 10000
        options:
          attachments: PluginModelSerializer.attachments(@model.attachmentList.models, ['id', 'name', 'url'])
          cardDetail: true
      .catch PluginRunner.Error.NotHandled, ->
        null
      .then (pluginCover) =>
        if !pluginValidators.isValidCover(pluginCover, true)
          @hasPluginCover = false
          return
        { url, height, size, edgeColor, position, padding } = pluginCoverWithDefaults(pluginCover)
        @hasPluginCover = true
        applyCover({ url, height, size, edgeColor, position, padding })
        @checkShowCover()
      .done()

    @checkShowCover()

    @

  renderCopyCard: ->
    hasBoards = _.any Auth.me().boardList.models, (board) -> !board.get('closed')
    @$('.js-copy-card').toggleClass('hide', !hasBoards)

  renderPluginButtons: ->
    subview = @subview PluginCardButtonsView, @model
    @appendSubview subview, @$('.js-plugin-buttons')
    @

  renderCustomFieldBadges: ->
    subview = @subview CustomFieldCardDetailBadgesView, @model, { sendPluginScreenEvent, sendPluginUIEvent }
    @appendSubview subview, @$('.js-custom-field-detail-badges')
    # only show the section if the Custom Fields Power-Up is enabled and there
    # are some fields defined on the board
    board = @model.getBoard()
    hideSection = !board.isCustomFieldsEnabled() || board.customFieldList.length == 0
    if !hideSection && !@model.editable()
      # hide the section if no custom field item on this card has a value
      hideSection = _.every(@model.customFieldItemList.models, (cfi) -> cfi.isEmpty())
    @$('.js-custom-fields-section').toggleClass('hide', hideSection)
    @

  renderPluginBadges: ->
    subview = @subview PluginCardDetailBadgesView, @model
    @appendSubview subview, @$('.js-plugin-badges')
    @

  renderStickers: ->
    $stickers = @$('.js-display-stickers').empty()
    stickers = @model.stickerList.models
    hasStickers = stickers.length > 0
    canRemove = @model.editable()

    if hasStickers
      subviews = (@subview(StickerView, sticker, { board: @model, canRemove }) for sticker in stickers)
      @appendSubviews(subviews, $stickers)

    @checkShowCover()

    @

  renderName: ->
    cardName = @model.get('name')
    boardName = @model.getBoard().get('name')

    # Hidden helper for accessibility and printing.
    @$('.js-title-helper').text(cardName)

    # Don't try and rerender while we're editing, we'll lose edits. Last
    # writer wins here.
    # We need to trigger a resize because the textarea won't resize for the
    # non-editing viewer.
    $input = @$('.js-card-detail-title-input')
    if !$input.hasClass('is-editing')
      $input.val(cardName).trigger('autosize.resize', false)

    # Controller.title needs a *string*, not HTML
    Controller.title(l('card detail title', { cardName, boardName }, { raw: true }))
    @

  renderDescription: ->
    desc = @model.get('desc')
    descHtml = TFM.description.format(desc ? '', { textData: @model.get('descData') }).output
    $desc = @$('.js-card-desc')
    $desc.empty().append(descHtml).data('unmarkeddown', desc)
    $desc.find('p').attr('dir', 'auto')
    friendlyLinks $desc[0], @model.getBoard()

    hasDesc = !/^\s*$/.test(descHtml)

    @$('.js-show-with-desc').toggleClass('hide', !hasDesc)
    @$('.js-hide-with-desc').toggleClass('hide', hasDesc)

    descriptionDraft = @$('.js-description-draft').val()?.length > 0
    @$('.js-hide-with-draft').toggleClass('hide', descriptionDraft)

    $('.js-desc-content').toggleClass('is-hide-full', @fHideFullDescription)

    @

  renderList: ->
    list = @model.getList()

    # It's possible that the list won't be loaded, if the card has been moved
    # to another board
    @$('.js-current-list')
      .html cardDetailListTemplate({
        listName: list?.get('name') ? "…",
        editable: @model.editable()
      })

    @

  renderArchived: ->
    isArchived = @model.get('closed') == true
    isInArchivedList = @model.getList()?.get('closed') == true

    # Uses @renderBanner instead if this flag is enabled.
    if !@cardTemplatesFlagEnabled
      showArchivedBanner = isArchived
      showArchivedListBanner = !isArchived && isInArchivedList

      # archive banner (or "in archived list" banner)
      @$('.js-archive-banner').toggleClass('hide', !showArchivedBanner)
      @$('.js-archived-list-banner').toggleClass('hide', !showArchivedListBanner)

    # sidebar buttons
    @$('.js-archive-card').toggleClass('hide', isArchived)
    @$('.js-unarchive-card').toggleClass('hide', !isArchived)

    @

  renderDelete: ->
    isArchived = @model.get('closed') == true
    shouldShowDeleteButton = isArchived || (
      @cardTemplatesFlagEnabled && !!@model.get('isTemplate')
    )

    @$('.js-delete-card').toggleClass('hide', !shouldShowDeleteButton)

    @

  showAllActions: (e) ->
    @fShowAllActions = true
    @renderShowAllActionsButton()
    @getData()

  renderShowAllActionsButton: ->
    isMoreToShow = getFilteredActionsCount(@model) >= @defaultActionLimit
    hideButton = @fShowAllActions || !isMoreToShow
    @$('.js-show-all-actions').toggleClass('hide', hideButton)

    @

  renderActionList: ->
    showDetails = !Auth.isLoggedIn() || Auth.me().getShowDetails()
    @actionListView.setShowDetails(showDetails)
    @waitForId @model, => @actionListView.render()
    @$('.js-show-details').toggleClass('hide', showDetails)
    @$('.js-hide-details').toggleClass('hide', !showDetails)
    return @

  renderMembers: (e) ->
    $memberList = @$('.js-card-detail-members-list').empty()
    members = @model.memberList.filterDeactivated(model: @model.getBoard()).models
    memberHtml = (@getMemberOnCardHtml(member) for member in members).join("")
    $memberList.html(memberHtml)

    if @model.editable() && !@isOnBoardTemplate()
      $memberList.append(cardDetailAddButtonTemplate(klass: 'js-details-edit-members mod-round'))

    @$('.js-card-detail-members').toggleClass('hide', members.length == 0)

    @renderSuggestedActions()

    @

  renderSuggestedActions: ->
    canJoin = @model.isValidSuggestion({ type: 'join' }, true)
    @$('.js-suggested-actions').toggleClass('hide', !canJoin)
    if canJoin
      trackDebounced.hour("Suggestions", "Card Detail", "Displayed", 1)
    @

  renderLabels: ->
    activeLabels = @model.getLabels().sort(Label.compare)

    $labels = @$('.js-card-detail-labels-list').empty()

    labelsHtml = for label in activeLabels
      data = @model.dataForLabel(label)
      data.extraClasses = ['mod-card-detail']
      if @model.editable()
        data.extraClasses.push('mod-clickable')
      labelTemplate(data)

    $labels.append(labelsHtml)

    if @model.editable()
      $labels
      .append(cardDetailAddButtonTemplate(klass: 'js-details-edit-labels'))
      .addClass('js-edit-label')

    @$('.js-card-detail-labels').toggleClass('hide', activeLabels.length == 0)

    @

  renderSubscribe: ->
    $subscribeSidebar = @$('.js-subscribe-sidebar-button')
    subscribed = @model.get('subscribed') || @model.get('badges')?.subscribed

    $subscribeSidebar.next('.toggle-button').remove()
    $subscribeSidebar.after cardDetailToggleButtonTemplate(
      isOn: subscribed
      text: 'watch'
      title: 'watch-the-card'
      icon: 'subscribe'
      selectorOn: 'js-unsubscribe'
      selectorOff: 'js-subscribe'
    )

    @$('.js-subscribed-indicator-header').toggleClass('hide', !subscribed)

    @

  renderCardTemplate: ->
    if @cardTemplatesFlagEnabled
      $templateSidebar = @$('.js-template-sidebar-button')
      $addHeading = @$('.js-sidebar-add-heading')
      $archiveButtonText = @$('.js-archive-card .js-sidebar-action-text')
      $unarchiveButtonText = @$('.js-unarchive-card .js-sidebar-action-text')

      isTemplate = !!@model.get('isTemplate')

      $templateSidebar.next('.toggle-button').remove()
      if isTemplate
        $templateSidebar.after cardDetailToggleButtonTemplate(
          isOn: isTemplate
          text: 'template'
          title: 'convert-this-template-back-to-a-card'
          icon: 'template-card'
          selectorOn: 'js-convert-to-card'
          selectorOff: 'js-convert-to-template'
        )

        $addHeading.text l(['templates', 'card_detail', 'add-to-template'])
        $archiveButtonText.text l(['templates', 'card_detail', 'hide-from-list'])
        $archiveButtonText.attr('title', l(['templates', 'card_detail', 'hide-from-list']))
        $unarchiveButtonText.text l(['templates', 'card_detail', 'show-in-list'])
        $unarchiveButtonText.attr('title', l(['templates', 'card_detail', 'show-in-list']))
      else
        $addHeading.text l(['templates', 'card_detail', 'add-to-card'])
        $archiveButtonText.text l(['templates', 'card_detail', 'archive'])
        $archiveButtonText.attr('title', l(['templates', 'card_detail', 'archive']))
        $unarchiveButtonText.text l(['templates', 'card_detail', 'send-to-board'])
        $unarchiveButtonText.attr('title', l(['templates', 'card_detail', 'send-to-board']))

      @$('.js-convert-to-template').toggleClass('hide', isTemplate)

      $cardHeaderIcon = @$('.js-card-header-icon')
      $cardHeaderIcon.toggleClass('icon-card', !isTemplate)
      $cardHeaderIcon.toggleClass('icon-template-card', isTemplate)
      @$('.js-convert-to-template').toggleClass('hide', isTemplate)

    @

  renderAging: ->
    board = @model.getBoard()
    agingActive = board.isPowerUpEnabled('cardAging')
    cardAgingPluginData = @model.getPluginData(CARD_AGING_POWER_UP_ID)
    if typeof cardAgingPluginData?.card?.shared == 'string'
      isEvergreen = JSON.parse(cardAgingPluginData.card.shared).evergreen

    $badge = @$('.js-card-detail-age-badge').removeClass @model.getAllAgingClasses()

    if agingActive
      data = @model.getAgingData()

      $badge
      # if date data isn't removed, Dates.formatDate will think nothing changed
      # and won't update.
      .removeData('date')
      .attr('dt', @model.get('dateLastActivity'))

      if data.mode == 'pirate' && !isEvergreen
        $badge.addClass data.agingClassesToAdd

      Dates.update(@$('.js-card-detail-age'))

    @$('.js-card-detail-age').toggleClass('hide', !agingActive)

    @

  # due date stuff
  renderDueDate: ->
    due = @model.get('due')
    dueComplete = @model.get('dueComplete')
    isTemplate = @cardTemplatesFlagEnabled && !!@model.get('isTemplate')

    @$('.js-add-due-date').toggleClass('hide', isTemplate)

    if !due || isTemplate
      @$('.js-card-detail-due-date').addClass('hide')
      return @

    dueDateDate = moment(due).calendar()
    relativeDueDateStatus = DueDateHelpers.relativeInfoForDueDate(due, dueComplete)

    classes = []
    classes.push DueDateHelpers.classForDueDate(due, dueComplete)
    if @model.editable()
      classes.push('is-clickable')

    $badge = @$('.js-card-detail-due-date-badge')
    .removeClass (index, css) ->
      # remove old badge state classes, like past, soon, future, etc.
      # http://stackoverflow.com/questions/2644299/jquery-removeclass-wildcard
      (css.match(/is-due-\S+/g) || []).join(" ")
    .addClass classes.join(' ')
    .attr 'title', DueDateHelpers.titleForDueDate(due, dueComplete)

    $badge.find('.card-detail-badge-due-date-button')
    .toggleClass('js-details-edit-due-date', @model.editable())

    $badge.find('.js-date-text')
    .text(dueDateDate)

    if relativeDueDateStatus
      $badge.find('.js-due-status')
      .removeClass('hide')
      .text(relativeDueDateStatus)
    else
      $badge.find('.js-due-status')
      .addClass('hide')

    $badge.find('.js-card-detail-due-date-badge-complete')
    .toggleClass('js-details-toggle-due-date-complete', @model.editable())

    @$('.js-card-detail-due-date').removeClass('hide')
    @

  renderVotes: ->
    # sidebar
    $voteSidebar = @$('.js-vote-sidebar-button')
    isTemplate = @cardTemplatesFlagEnabled && !!@model.get('isTemplate')

    $voteSidebar.next('.toggle-button').remove()
    if !isTemplate
      $voteSidebar.after cardDetailToggleButtonTemplate(
        isOn: @model.voted()
        disabled: !@model.getBoard().canVote(Auth.me())
        icon: 'vote'
        text: 'vote'
        selectorOn: 'js-unvote'
        selectorOff: 'js-vote'
      )

    hideVotes = !!@model.getBoard().get('prefs').hideVotes
    numVotes = @model.get('badges')?.votes ? 0

    if numVotes
      viewingMemberVoted = @model.get('badges')?.viewingMemberVoted
      if hideVotes || isTemplate
        @$('.js-card-detail-votes').addClass('hide')
      else
        @$('.js-card-detail-votes-badge')
        .text(localizeCount('votes', numVotes))
        .toggleClass('is-voted', viewingMemberVoted ? false)
        @$('.js-card-detail-votes').toggleClass('hide', numVotes == 0)
    else
      # No more votes to show, so hide the popup
      if PopOver.view instanceof MembersVotedView
        PopOver.hide()

    @

  sortChecklists: ->
    $checklistList = @$('.js-checklist-list')
    Util.withoutAlteringSelection =>
      @model.checklistList.forEach (checklist) =>
        checklistView = @existingSubview(ChecklistView, checklist)
        $checklistList.append checklistView.el
    @

  removeChecklist: (checklist) ->
    @deleteSubview(@existingSubview(ChecklistView, checklist))

  renderChecklists: ->
    log('render', "rendering checklists")
    $checklistList = @$('.js-checklist-list').empty()

    subviews = (@subview(ChecklistView, checklist, { card: @model }) for checklist in @model.checklistList.models)
    @appendSubviews(subviews, $checklistList)

    DragSort.refreshIfInitialized($checklistList)

    if @model?.editable()
      DragSort.refreshCardSortable @$('.js-checklist-list'),
        axis: 'y'
        handle: '.window-module-title'
        delay: 75
        distance: 7
        tolerance: 'pointer'
        placeholder: 'checklist placeholder'
        items: '.checklist'
        start: (event, ui) ->
          _height = $(ui.helper).outerHeight()
          $(ui.placeholder).height(_height)

    @

  showFewerAttachments: (e) ->
    Util.stop(e)
    @fShowAllAttachments = false
    @renderAttachments()
    return

  showMoreAttachments: (e) ->
    Util.stop(e)
    @fShowAllAttachments = true
    @renderAttachments()
    return

  showFewerTrelloAttachments: (e) ->
    Util.stop(e)
    @fShowAllTrelloAttachments = false
    @renderAttachments()
    return

  showMoreTrelloAttachments: (e) ->
    Util.stop(e)
    @fShowAllTrelloAttachments = true
    @renderAttachments()
    return

  dismissDropboxSection: (target) ->
    Confirm.toggle 'dismiss dropbox section',
      elem: target
      confirmBtnClass: 'primary'
      fxConfirm: =>
        board = @model.getBoard()
        # we are going to store the dismissal in the users private board pluginData
        dropboxPluginData = board.getPluginData(DropboxPluginId)
        updatedData = { dismissedSection: true }
        if _.isString(dropboxPluginData?.board?.private)
          parsed = JSON.parse(dropboxPluginData.board.private)
          parsed.dismissedSection = true
          updatedData = parsed
        board.setPluginData(DropboxPluginId, 'private', JSON.stringify(updatedData))
        @renderAttachmentsDebounced()
        # make sure we know about the Dropbox plugin before generating the event
        board.getAvailablePlugins()
        .then ->
          sendPluginUIEvent(DropboxPluginId, {
            action: 'clicked'
            actionSubject: 'button'
            actionSubjectId: 'dismissDropboxSuggestionButton'
            source: 'dropboxAttachmentSection'
          })
    return

  enableDropboxPrompt: (target) ->
    # make sure we know about the Dropbox plugin
    @model.getBoard().getAvailablePlugins()
    .then (plugins) -> plugins.find((plugin) => plugin.id == DropboxPluginId)
    .then (dropboxPlugin) =>
      PopOver.toggle
        elem: target
        view: new PluginSuggestionPopOver({
          model: dropboxPlugin
          card: @model
          board: @model.getBoard()
        })
        autoPosition: true
        getViewTitle: => 'Dropbox'

      sendPluginUIEvent(DropboxPluginId, {
        action: 'clicked'
        actionSubject: 'button'
        actionSubjectId: 'enableDropboxSuggestionButton'
        source: 'dropboxAttachmentSection'
      })
    return

  renderPluginSections: ->
    @_renderPluginSectionsPromise?.cancel()

    @_renderPluginSectionsPromise = Promise.try =>
      PluginRunner.all
        timeout: 5000
        command: 'card-back-section'
        card: @model
        board: @model.getBoard()
        list: @model.getList()
    .cancellable()
    .then (pluginCardBackSections) =>
      subviews = _.chain(pluginCardBackSections)
        .filter (section) -> pluginValidators.isValidCardBackSection(section)
        .uniq((p) -> p.idPlugin)
        .map (section) =>
          subviewId = "card-back-section_#{section.content.url}_#{section.idPlugin}"
          subview = @subview PluginCardBackSectionView, @model, {}, subviewId
          subview.updateSection(section)
          subview
        .compact()
        .value()

      idPlugins = _.chain(pluginCardBackSections).pluck('idPlugin').uniq().value()
      for idPlugin in idPlugins
        trackUe('card details', 'views', 'Power-Up', '', '', 'card-back-section', idPlugin)

      $pluginSections = @$('.js-plugin-card-back-sections')
      @ensureSubviews(subviews, $pluginSections)

    .catch Promise.CancellationError, (->)

    @_renderPluginSectionsPromise.done()
    @

  renderAttachments: ->
    @_renderAttachmentsPromise?.cancel()

    allAttachments = _.clone(@model.attachmentList.models).reverse()

    board = @model.getBoard()
    availablePlugins = board.getAvailablePlugins()

    @_renderAttachmentsPromise = Promise.all([
      Promise.all(allAttachments.map(AttachmentHelpers.getAttachmentData)),

      Promise.try =>
        if allAttachments.length > 0
          PluginRunner.all
            timeout: 5000
            command: 'attachment-sections'
            card: @model
            board: @model.getBoard()
            options:
              entries: PluginModelSerializer.attachments(allAttachments)
        else
          []
      .cancellable()
    ])
    .spread (allAttachmentData, pluginAttachmentSections) =>
      displayedInSection = {}
      usedSubviewIds = {}

      subviews = _.chain(pluginAttachmentSections)
        .filter (section) => pluginValidators.isValidAttachmentSections(section, @model.attachmentList)
        .map (section) =>
          _.forEach section.claimed, (entry) ->
            displayedInSection[entry.id] = true

          subviewId = section.id || section.title
          if _.isFunction(subviewId) || usedSubviewIds[subviewId]
            subviewId = _.uniqueId('attachment-section_')
          usedSubviewIds[subviewId] = true
          subview = @subview PluginSectionView, @model, {}, subviewId
          subview.updateSection(section)
          subview
        .value()

      trelloAttachments = @getTrelloAttachments(allAttachments, allAttachmentData, displayedInSection)
      trelloAttachments.forEach(({ attachment }) -> displayedInSection[attachment.id] = true)

      idPlugins = _.chain(pluginAttachmentSections).pluck('idPlugin').uniq().value()
      for idPlugin in idPlugins
        trackUe('card details', 'views', 'Power-Up', '', '', 'attachment-sections', idPlugin)

      $pluginSections = @$('.js-plugin-sections')
      @ensureSubviews(subviews, $pluginSections)

      # if the Dropbox Power-Up is NOT enabled pull out into its own section
      # with a CTA as part of partnership deal with Dropbox
      dropboxAttachments = []
      if board.suggestDropbox()
        # we need to 'claim' the dropbox ones so they don't double render
        allAttachments.forEach (attachment) ->
          attachmentHost = ''
          try
            attachmentHost = new URL(attachment.get('url')).host
          if DropboxClaimedHosts.includes(attachmentHost)
            displayedInSection[attachment.id] = true
            dropboxAttachments.push(_.pick(attachment.attributes, 'id', 'name', 'url', 'date'))

      renderComponent(React.createElement(DropboxSection, {
        suggest: board.suggestDropbox()
        dropboxAttachments: dropboxAttachments
        onDismiss: (target) => @dismissDropboxSection(target)
        onRemoveAttachment: (idAttachment) -> allAttachments.find((a) -> a.id == idAttachment)?.destroy()
        onEnable: (target) => @enableDropboxPrompt(target)
      }), @$('.js-plugin-suggestion-sections')[0])

      initialNumToShow = 4
      numShown = 0
      remainingAttachments = []

      for i, attachment of allAttachments
        if numShown == initialNumToShow or numShown == allAttachments.length
          break

        remainingAttachments.push(attachment)

        if not displayedInSection.hasOwnProperty(attachment.id)
          numShown++

      nonPluginAttachments = _.reject allAttachments, (attachment) ->
        displayedInSection[attachment.id]

      hasAttachments = numShown > 0
      hasOverflow = numShown < nonPluginAttachments.length

      $attachmentsSection = @$('.js-attachments-section')
      $trelloAttachmentsSection = @$('.js-trello-attachments-section')
      $attachmentsList = $attachmentsSection.find('.js-attachment-list')

      trelloAttachmentSubviews =
        if (processingTrelloAttachmentsCount = @numTrelloAttachmentsProcessing.get())
          _.times Math.min(3, processingTrelloAttachmentsCount), (index) =>
            @subview InProgressAttachmentView, @model, null, "processing-trello-attachment-#{ index }"
        else
          []

      if trelloAttachments.length > 0
        numHiddenTrelloAttachments = (trelloAttachments.length - initialNumToShow).toString()

        if numHiddenTrelloAttachments > 0
          if not @fShowAllTrelloAttachments
            trelloAttachments = trelloAttachments.splice(0, initialNumToShow)

            $trelloAttachmentsSection.find('.js-show-more-trello-attachments').removeClass('hide')
            $trelloAttachmentsSection.find('.js-show-fewer-trello-attachments').addClass('hide')
            $trelloAttachmentsSection.find('.js-view-all-trello-attachments').text l('view all trello attachments', {
              hiddenCount: numHiddenTrelloAttachments
            })
          else
            $trelloAttachmentsSection.find('.js-show-more-trello-attachments').addClass('hide')
            $trelloAttachmentsSection.find('.js-show-fewer-trello-attachments').removeClass('hide')
        else
          $trelloAttachmentsSection.find('.js-show-more-trello-attachments').addClass('hide')
          $trelloAttachmentsSection.find('.js-show-fewer-trello-attachments').addClass('hide')

        trelloAttachmentSubviews = trelloAttachmentSubviews.concat(
          trelloAttachments.map ({ attachment, attachmentData }) =>
            if attachmentData.type == 'trello card'
              @subview TrelloCardAttachment, attachment, { cardUrl: attachmentData.url }
            else
              @subview TrelloBoardAttachment, attachment, { boardUrl: attachmentData.url }
        )

      @ensureSubviews(trelloAttachmentSubviews, @$('.js-trello-attachments-list'))
      $trelloAttachmentsSection.toggleClass('hide', _.isEmpty(trelloAttachmentSubviews))

      @$('.js-show-with-attachments').toggleClass('hide', !hasAttachments )

      @enableAttachmentSorting($attachmentsList)

      hiddenCount = (nonPluginAttachments.length - initialNumToShow).toString()
      $attachmentsSection.find('.js-view-all-attachments').text l('view all attachments', { hiddenCount })
      $attachmentsShowFewer = $attachmentsSection.find('.js-show-fewer-attachments').addClass('hide')
      $attachmentsShowMore = $attachmentsSection.find('.js-show-more-attachments').addClass('hide')

      processingSubviews =
        if (processingCount = @numAttachmentsProcessing.get())
          _.times Math.min(3, processingCount), (index) =>
            @subview InProgressAttachmentView, @model, null, "processing-#{ index }"
        else
          []

      attachmentSubviews =
        if hasAttachments
          attachmentModels = allAttachments

          if hasOverflow
            if !@fShowAllAttachments
              $attachmentsShowMore.removeClass('hide')
              attachmentModels = remainingAttachments
            else
              $attachmentsShowFewer.removeClass('hide')

          attachmentModels.map (attachment) =>
            if displayedInSection.hasOwnProperty(attachment.id)
              return

            @subview AttachmentThumbView, attachment, {
              onReply: => @replyToAttachment(attachment)
              onPluginThumbnail: (idPlugin) =>
                if !@pluginThumbTrackCache[idPlugin]
                  @pluginThumbTrackCache[idPlugin] = true
                  trackUe('card details', 'views', 'Power-Up', '', '', 'attachment-thumbnail', idPlugin)
            }
        else
          []

      subviews = _.compact [processingSubviews..., attachmentSubviews...]
      @ensureSubviews(subviews, $attachmentsList)

      $attachmentsSection.toggleClass('hide', _.isEmpty(subviews) )

    .catch Promise.CancellationError, (->)

    @_renderAttachmentsPromise.done()
    @

  renderEditing: ->
    members = @model.memberEditingList.models

    data =
      members: for mem in members when !Auth.isMe(mem) && mem.get('editing')?
        memberData = mem.toJSON()
        memberData.icon = switch mem.get('editing').action
          when 'commenting' then 'comment'
          when 'editing' then 'edit'
          else 'edit'
        memberData

    @$('.js-editing-members')
      .empty()
      .append editInProgressTemplate(data)
      .toggleClass('hide', data.members.length == 0)

    @

  sortStop: (e, ui) ->
    Util.stopPropagation(e)
    ui.item.trigger('movechecklist', [ui])
    return

  sortStopAttachments: (e, ui) ->
    Util.stopPropagation(e)
    ui.item.trigger('moveattachment', [ui])

  keydownEvent: (e) ->
    # We're overriding keydownEvent from EditableView
    super
    Auth.me().editing({
      idBoard: @model.getBoard().id
      idCard: @model.id
      action: 'editing'
    })

  keydownCommentEvent: (e) ->
    Auth.me().editing({
      idBoard: @model.getBoard().id
      idCard: @model.id
      action: 'commenting'
    })

    key = getKey(e)

    if key == Key.Tab and $(e.target).hasClass('new-comment-input') and @model.editable() and !(PopOver.view instanceof AutoMentionerView) and $(e.target).val() == ""
      Util.stop(e)
      @submitComment(e)

    if isForceSubmitEvent(e) && !@_isCommentTooLong()
      @submitComment(e)
    else
      @checkInsert(e)

  _isCommentTooLong: ->
    @$('.js-new-comment-input').val()?.length > @maximumCommentLength

  renderCommentSubmitAbility: (e) ->
    isTooLong = @_isCommentTooLong()
    noInput = @$('.js-new-comment-input').val()?.length == 0
    isDisabled = noInput || isTooLong
    @$('.js-add-comment').prop('disabled', isDisabled)
    @$('.js-comment-subscribe').toggleClass('is-visible', !isDisabled && !@model.isSubscribed())
    @$('.comment-too-long-warning').toggleClass('is-shown', isTooLong)
    @$('.comment-too-long-warning').find('.js-attach-comment').toggle(Blob?)
    @renderCommentControls()
    @

  renderCommentControls: (e) ->
    $comment = @$('.js-new-comment')
    hasInput = @$('.js-new-comment-input').val()?.length > 0
    $comment.toggleClass('is-show-controls', hasInput)
    @

  renderCommentAndSubscribeBox: (e) ->
    @$('.js-comment-subscribe').toggleClass('is-subscribed')
    @

  _cancelEditing: ->
    Auth.me().editing({ idBoard: @model.getBoard().id })

  commentInputEvent: (e) ->
    @renderCommentSubmitAbility()
    @renderCommentControls()
    @$('.js-new-comment-input').trigger('autosize.resize')
    @

  clearComment: ->
    $input = $(@commentInput)

    $input
    .val('')
    .css('height', '') # In case they resized the textarea

    @renderCommentSubmitAbility()

  submitComment: (e) ->
    track("Card Detail", "Comment", "Submit Comment", @model.trackProperty())
    Util.stop(e)

    $input = $(@commentInput)
    text = $input.val()

    @clearComment()

    @_cancelEditing()
    @model.addComment(text)

    # Tracking for direct mentions of invitees
    mentionedUsernames = text?.match(/@\w+/g)?.map((s) -> s.substring(1).toLowerCase()) ? []
    mentionedUsernames = _.uniq(mentionedUsernames)
    boardMembers = @model.getBoard().memberList.models
    myId = Auth.me().id
    mentionedUsernames.forEach((mentionedUsername) ->
      if mentionedUsername != "card" and mentionedUsername != "board" and mentionedUsername != "commenters"
        # Find the board member with this username, see if we invited them
        boardMembers.forEach((boardMember) ->
          if boardMember.get('username') == mentionedUsername and boardMember.get('idMemberReferrer') == myId
            trackUe('card detail', 'mentions', 'invitee', '', '', '', { member: myId, mentionedMember: boardMember.id })
        )
    )

    if Auth.me().isSubscribeOnCommentEnabled() && !@model.isSubscribed()
      @model.subscribe(true)

    Layout.cancelEdits()
    @collapseComment()
    @renderCommentSubmitAbility()

    PopOver.hide()

    false

  subscribeOnComment: (e) ->
    Util.stop(e)

    me = Auth.me()

    if !me.isSubscribeOnCommentEnabled()
      track("Card Detail", "Comment and Subscribe", "Enable", @model.trackProperty())
    else
      track("Card Detail", "Comment and Subscribe", "Disable", @model.trackProperty())

    @renderCommentAndSubscribeBox()

    me.toggleSubscribeOnComment()

    false

  clearEdits: ->
    @_cancelEditing()
    super

  commitEdits: ->
    @_cancelEditing()
    # to hide the 'Edit' button for the description field
    @$('.card-detail-description .editing').removeClass('editing')
    super

  stopEditing: ->
    @_cancelEditing()
    super

  truncateComment: (e) ->
    $comment = @$('.js-new-comment-input')
    $comment.val($comment.val().substr(0, @maximumCommentLength))
    @$('.js-new-comment-input').autosize(append: false)
    @renderCommentSubmitAbility()

  attachComment: (e) ->
    file = new Blob([@$('.js-new-comment-input').val()], { type: 'text/plain' })
    @incrementNumAttachmentsProcessing()
    @model.upload file, 'comment.txt', @callback =>
      @decrementNumAttachmentsProcessing()

    @clearComment()
    Layout.cancelEdits()
    @collapseComment()

  inputComment: (e) ->
    $comment = @$('.js-new-comment')
    Layout.cancelEdits(@commentInput)
    $comment.addClass('is-focused')
    @$('.js-new-comment-input').autosize(append: false)
    return

  clickAwayFromComment: (e) ->
    # If there's a popover open, and someone "clicks away," they're
    # *probably* trying to dismiss the popover, not the comment box.
    if PopOver.isVisible
      return

    # Don't collapse the comment box unless the textarea has blurred.
    # This fixes a bug where you can `mousedown` (to focus the textarea)
    # hold your mouse down, move it out of the comment box, then
    # release (`click`), causing the comment box to collapse.
    if (document.activeElement == @commentInput)
      return

    # Don't collapse if we're clicking anywhere inside the comment area,
    # like on buttons.
    el = e.target
    $comment = @$('.js-new-comment')

    # We might not have a comment input if we're in template or don't
    # have permission to comment
    if $comment[0]?.contains(el)
      return

    @collapseComment()

  collapseComment: ->
    @$('.js-new-comment').removeClass('is-focused')
    @$('.js-new-comment-input').trigger('autosize:destroy')

  replyToAction: (e, action) ->
    memberCreator = @modelCache.get('Member', action.get('idMemberCreator'))
    username = memberCreator?.get('username')

    $comment = @$(@commentInput)

    replyText =
      if action.isCommentLike() && username?
        Layout.cancelEdits(@commentInput)
        # Only add the @mention if they haven't already added one; maybe they
        # clicked 'reply' twice or something
        if ///@#{ username }(\W|$)///.test($comment.val())
          $comment.focus()
          null
        else
          "@#{username} "
      else if action.isAddAttachment() && (attachment = @model.attachmentList.get(action.get('data').attachment?.id))?
        attachmentMarkdown = attachmentAsMarkdown(attachment)
        if Auth.isMe(memberCreator)
          attachmentMarkdown
        else
          ["@#{ username }", attachmentMarkdown].join(' ')

    if replyText
      $comment.addClass('is-focused')
      Util.insertSelection($comment, replyText)
      $comment.trigger('autosize.resize')
      @$('.js-new-comment-input').autosize(append: false)

    return

  replyToAllAction: (e, action) ->
    memberCreator = @modelCache.get('Member', action.get('idMemberCreator'))
    username = memberCreator?.get('username')

    # Cache the current values for comment
    $comment = @$(@commentInput)
    commentText = $comment.val()

    mentionsFromText = (markdown) ->
      _.uniq(TFM.comments.getMatches(markdown, { 'atMention': true }).atMention)

    mentions = _.chain(["@#{ username }"])
      .concat(mentionsFromText(action.get('data').text))
      .uniq((a) -> a.toLowerCase())
      .filter (mention) ->
        [username, isMe] = TFM.lookupMember mention.replace '@', ''
        !isMe
      .without(
        mentionsFromText(commentText)...
      )
      .value()

    # Tracking for @card then remove them
    if(_.contains(mentions, '@card') || _.contains(mentions, '@board'))
      track("Card", "Reply to all with a @card or @board mention", undefined, @model.trackProperty())

    mentions = _.without(mentions, '@card', '@board')

    # Track how many users have been added
    track("Card", "Reply to all Comment Mention Count", undefined, @model.trackProperty(), mentions.length)

    if mentions.length
      replyText = mentions.join(" ") + " "
      $comment.addClass('is-focused')
      Util.insertSelection($comment, replyText)
      $comment.trigger('autosize.resize')
    else
      $comment.focus()

    return

  replyToAttachment: (attachment) ->
    Layout.cancelEdits(@commentInput)
    $comment = @$(@commentInput)
    $comment.addClass('is-focused')
    Util.insertSelection($comment, attachmentAsMarkdown(attachment))
    $comment.trigger('autosize.resize')

  getCard: ->
    @model

  getTextInput: ->
    descInput = @$('.js-description-draft')
    if descInput.is(document.activeElement)
      return descInput
    return @$('.js-new-comment-input')

  getMentionTarget: ->
    descInput = @$('.js-description-draft')
    if descInput.is(document.activeElement)
      return descInput[0]
    return @$('.js-comment-mention-member:visible')[0]

  getEmojiTarget: ->
    descInput = @$('.js-description-draft')
    if descInput.is(document.activeElement)
      return descInput[0]
    return @$('.js-comment-add-emoji:visible')[0]

  # edit members
  openEditMembersPopOver: (elem) ->
    PopOver.toggle
      elem: elem
      view: CardMemberSelectView
      options: { @model, @modelCache }
    return

  editMembersMain: (e) ->
    Util.stop(e)
    @openEditMembersPopOver(@$('.js-details-edit-members'))
    track("Card Detail", "Edit Members via Main Column", undefined, @model.trackProperty())
    return

  changeMembersSidebar: (e) ->
    Util.stop(e)
    @openEditMembersPopOver(@$('.js-change-card-members'))
    track("Card Detail", "Sidebar", "Open Manage Member Menu", @model.trackProperty())
    return

  join: (e) ->
    Util.stop(e)
    @model.addMember(Auth.myId())
    track("Card Detail", "Suggested", "Join", @model.trackProperty())

  onChecklistClick: (e) ->
    Util.preventDefault(e)
    track('Card Detail', "Add Checklist Button", "Open Add Checklist Menu", @model.trackProperty())
    @addChecklistSidebar(e.target)

  onChecklistShortcut: ->
    @addChecklistSidebar(@$('.js-add-checklist-menu'))

  addChecklistSidebar: (mountPoint) ->
    PopOver.toggle
      elem: mountPoint
      view: AddChecklistMenu
      options: { @model, @modelCache, cardView: @ }

    false

  showDueDateBadgeMenu: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-details-edit-due-date')
      view: DatePickerView
      options: { @model, @modelCache, trackingCategory: 'card detail' }

    track("Card Detail", "Due Date Badge", "Open Due Date Menu", @model.trackProperty())
    return

  toggleDueDateComplete: (e) ->
    newValue = !@model.get('dueComplete')
    @model.update({
      dueComplete: newValue
    })

    if @confettiEnabled && newValue && (shouldFireConfetti(@model.get('name')) || shouldFireConfetti(@model.getList().get('name')))
      confetti({
        angle: _.random(55, 125)
        spread: _.random(50, 70)
        particleCount: _.random(40, 75)
        origin: {
          x: e.pageX / window.innerWidth
          y: e.pageY / window.innerHeight
        }
      })

    track("Card Detail", "Due Date Badge", (if newValue then "Marked Complete" else "Marked Incomplete"), @model.trackProperty())

  openAttachPicker: (e) ->
    Util.stop(e)

    elem = $(e.target).closest('.js-attach')

    PopOver.toggle
      elem: elem
      view: AttachmentTypePickerView
      options: {
        @model
        @modelCache
        onStartUpload: (card, type) =>
          if type == 'card' || type == 'board'
            @incrementNumTrelloAttachmentsProcessing()
          else
            @incrementNumAttachmentsProcessing()
        onFinishUpload: (card, type) =>
          if type == 'card' || type == 'board'
            @decrementNumTrelloAttachmentsProcessing()
          else
            @decrementNumAttachmentsProcessing()
      }

    type = if $(elem).hasClass('inline')
      "Inline"
    else if $(elem).hasClass('quiet-button')
      "Quiet"
    else
      "Sidebar"
    track("Card Detail", "Open Attachment Type Picker", "Via #{type} Button", @model.trackProperty())

    false

  openAttachTrelloPicker: (e) ->
    Util.stop(e)

    elem = $(e.target).closest('.js-attach-trello-attachment')
    track("Card Detail", "Open Trello Attachment Picker", "Via Trello Attachments Section", @model.trackProperty())

    PopOver.toggle
      elem: elem
      view: TrelloCompleterView
      options: {
        @model
        @modelCache
        card: @model
        button: true
        onStartUpload: (card) =>
          @incrementNumTrelloAttachmentsProcessing()

          PopOver.pushView
            view: UploadingLinkView

          url = card.get('url')
          Promise.fromNode (next) => @model.uploadUrl(url, next)
          .catch LimitExceeded, =>
            Alerts.show("unable to attach card or board", 'error', 'trelloattachment', 5000)
          .then ->
            PopOver.popView()
          .finally =>
            @decrementNumTrelloAttachmentsProcessing()
      }

    false

  dueDateSidebar: (e) ->
    Util.preventDefault(e)

    PopOver.toggle
      elem: @$('.js-add-due-date')
      view: DatePickerView
      options: { @model, @modelCache, trackingCategory: 'card detail' }

    track("Card Detail", "Sidebar", "Open Due Date Menu", @model.trackProperty())
    false

  cardCoverChooserSidebar: (e) ->
    Util.preventDefault(e)

    toggleCardCoverChooserPopover({
      elem: @$(e.currentTarget)
      cardId: @model.id
    })

    inHeader = @$(e.currentTarget).closest('.js-card-cover-box').length > 0

    attachments = @model.attachmentList.toJSON()
    coverAttachmentCount = getPotentialCovers(attachments).length
    hasPotentialCovers = coverAttachmentCount > 0 || @model.hasCover()
    hasCoversProperty = if hasPotentialCovers then "Has Potential Covers" else "No Covers"

    if inHeader
      track("Card Detail", "Card Cover Area", "Open Card Cover Chooser", hasCoversProperty, coverAttachmentCount)
      track("Card Detail", "Card Cover Area", "Open Card Cover Chooser", @model.trackProperty())
    else
      track("Card Detail", "Sidebar", "Open Card Cover Chooser", hasCoversProperty, coverAttachmentCount)
      track("Card Detail", "Sidebar", "Open Card Cover Chooser", @model.trackProperty())
    false

  editFieldsSidebar: (e) ->
    Util.preventDefault(e)

    PopOver.toggle
      elem: @$('.js-edit-fields')
      view: CustomFieldsButtonView
      options: { @model, @modelCache, board: @model.getBoard() }

    track("Card Detail", "Sidebar", "Open Custom Fields Menu", @model.trackProperty())
    sendPluginUIEvent(CUSTOM_FIELDS_ID, {
      action: 'clicked'
      actionSubject: 'button'
      source: 'cardDetailScreen'
      actionSubjectId: 'cardButton'
      objectType: 'powerUp'
      objectId: CUSTOM_FIELDS_ID
    })
    false

  subscribeToCard: (e) ->
    @model.subscribe(true)
    track("Card Detail", "Sidebar", "Subscribe", @model.trackProperty())
    @renderCommentSubmitAbility()
    false

  unsubscribeFromCard: (e) ->
    @model.subscribe(false)
    track("Card Detail", "Sidebar", "Unsubscribe", @model.trackProperty())
    @renderCommentSubmitAbility()
    false

  vote: (e) ->
    Util.preventDefault(e)
    @model.vote(true)
    track("Card Detail", "Sidebar", "Vote", @model.trackProperty())
    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-button', LegacyPowerUps.voting)
    sendPluginUIEvent(LegacyPowerUps.voting, {
      action: 'clicked'
      actionSubject: 'button'
      source: 'cardDetailScreen'
      actionSubjectId: 'cardButton'
      objectType: 'powerUp'
      objectId: LegacyPowerUps.voting
    })
    false

  unvote: (e) ->
    Util.preventDefault(e)
    track("Card Detail", "Sidebar", "Unvote", @model.trackProperty())
    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-button', LegacyPowerUps.voting)
    sendPluginUIEvent(LegacyPowerUps.voting, {
      action: 'clicked'
      actionSubject: 'button'
      source: 'cardDetailScreen'
      actionSubjectId: 'cardButton'
      objectType: 'powerUp'
      objectId: LegacyPowerUps.voting
    })
    @model.vote(false)
    false

  openFormatHelp: (e) ->
    track("Card Detail", "Formatting Help")

    PopOver.toggle
      elem: @$('.js-format-help')
      view: FormattingHelpView
      options: { @model, @modelCache }
      # use keepEdits so the editable field doesn't close
      # and hide $('.js-format-help'), which we bind to
      keepEdits: true

    false

  dragenter: (e) ->
    if !@model.editable()
      return

    limited = false
    restricted = !@model.canDropAttachment(e.type)

    if restricted
      classname = '.attachments-restricted'
    else if @model.isOverLimit('attachments', 'perCard')
      className = '.attachments-per-card'
      limited = true
    else if @model.getBoard().isOverLimit('attachments', 'perBoard')
      className = '.attachments-per-board'
      limited = true
    else
      className = '.dropzone'

    _scrollTop = $('.window-overlay').scrollTop() + 200

    @$(className).css
      'padding-top': "#{_scrollTop}px"
    @$el
    .addClass('is-drophover')
    .toggleClass('is-limited', limited)
    .toggleClass('is-restricted', restricted)

  dragleave: (e) ->
    @$el.removeClass('is-drophover')

  dropFiles: (e) ->
    if !@model.canAttach() || @model.attachmentTypeRestricted('computer')
      return

    track("Card Detail", "Drop Attachment Upload")
    files = e.detail

    if warnIfFileTooLarge(@model.getBoard(), files)
      return

    @incrementNumAttachmentsProcessing(files.length)

    processed = 0
    Promise.resolve(files)
    .each (file) =>
      name = file.name || pastedFileName()
      ninvoke @model, 'upload', file, name
      .finally @callback =>
        processed++
        @decrementNumAttachmentsProcessing()
    .catch ->
      Alerts.show("unable to upload file", 'error', 'upload', 5000)
    .finally =>
      if processed != files.length
        @decrementNumAttachmentsProcessing(files.length - processed)
    .done()

    e.stopPropagation()

  dropUrl: (e) ->
    if !@model.canAttach()
      return

    track("Card Detail", "Drop Attachment Url", undefined, @model.trackProperty())
    url = e.detail

    board = @model.getBoard()
    if board.attachmentUrlRestricted(url)
      return

    isTrelloAttachment = parseTrelloUrl(url).type in ['board', 'card']

    if isTrelloAttachment
      @incrementNumTrelloAttachmentsProcessing()
    else
      @incrementNumAttachmentsProcessing()

    @model.uploadUrl url, @callback =>
      if isTrelloAttachment
        @decrementNumTrelloAttachmentsProcessing()
      else
        @decrementNumAttachmentsProcessing()

    e.stopPropagation()

  focusChecklistAdd: (checklist) ->
    @existingSubview(ChecklistView, checklist).focusNewTaskInput()

  closeDialog: ->
    Dialog.hide()

  highlight: (highlight, scrollIntoView) ->
    if (parts = /^([a-z]+)-([a-f0-9]{24})$/.exec(highlight))?
      [all, type, id] = parts
      switch type
        when 'action', 'comment'
          @actionListView.setHighlight(id)
          if !@model.actionList.get(id)
            @showAllActions()
          if scrollIntoView
            @scrollToHighlight()

    return

  replyToComment: (replyToComment) ->
    if @model.getBoard().canComment(Auth.me()) && replyToComment
      $newCommentInput = @$('.js-new-comment-input')
      $newCommentInput.val("@#{replyToComment} ")
      $newCommentInput.focus()
      Util.setCaretAtEnd($newCommentInput[0])

    @renderCommentSubmitAbility()

    return

  # If the user clicks on a link that points to something on the card we're
  # already looking at, don't do the whole navigation thing and instead just
  # skip to running the highlight code
  interceptHighlightLink: (e) ->
    # So I'm not sure how exactly this happens, given that we've selected
    # for a[href], but we are getting error reports that indicate that
    # e.target.href is undefined sometimes
    if !e.target.href
      return

    url = Util.relativeUrl(e.target.href)
    cardUrl = Controller.getCardUrl(@model)
    if (parts = ///^ #{cardUrl} \# ([^\#]+) $///.exec(url))?
      [all, highlight] = parts
      if highlight
        Util.stop(e)

        # Toggle the hash off if we're already on this one
        if highlight == location.hash.substr(1)
          history.replaceState(null, null, location.pathname)
          @actionListView.setHighlight(null)
        else
          history.replaceState(null, null, location.pathname + "#" + highlight)
          @highlight(highlight, true)
    return

  showDetails: (e) ->
    Util.stop(e)
    Auth.me().setShowDetails(true)
    @getData()
    @renderActionList()

  hideDetails: (e) ->
    Util.stop(e)
    Auth.me().setShowDetails(false)
    @getData()
    @renderActionList()

  enableAttachmentSorting: ($attachmentsList) ->
    if @model?.editable()
      DragSort.refreshCardSortable $attachmentsList,
        axis: 'y'
        handle: [
          '.attachment-thumbnail-details'
          '.attachment-thumbnail-preview'
        ].join(',')
        delay: 75
        distance: 7
        tolerance: 'pointer'
        helper: 'clone'
        placeholder: 'attachment-thumbnail placeholder'
        items: '.attachment-thumbnail'
        start: (event, ui) ->
          _height = $(ui.helper).outerHeight()
          $(ui.placeholder).height(_height)

  getTrelloAttachments: (attachments, allAttachmentData, claimedAttachments) ->
    attachmentTypes = ['trello board', 'trello card']

    attachments.map((attachment, i) =>
      attachmentData = allAttachmentData[i]
      if attachmentData.isKnownService and attachmentData.type in attachmentTypes and !claimedAttachments[attachment.id]
        { attachment, attachmentData }
      else
        null
    ).filter((a) => a != null)

  editLocationSidebar: (e) ->
    Util.preventDefault(e)

    trackUe('card detail', 'opens', 'Power-Up', '', '', 'card-button', MAP_POWER_UP_ID)
    trackUe(Noun.CARD_DETAILS, Verb.OPENS, 'location menu', '', '', 'by clicking the location sidebar item', {
      idCard: @model.id
      idList: @model.getList().id
      idBoard: @model.getBoard().id
    })
    sendPluginUIEvent(MAP_POWER_UP_ID, {
      action: 'clicked'
      actionSubject: 'button'
      source: 'cardDetailScreen'
      actionSubjectId: 'cardMapLocationButton'
      objectType: 'powerUp'
      objectId: MAP_POWER_UP_ID
    })

    PopOver.toggle
      elem: @$('.js-edit-location')
      view: SetCardLocationPopoverView
      options: { @model, @modelCache, trackingMethod: 'by clicking on the location button' }

    false

  renderLocation: ->
    isEnabled = @model.getBoard().isMapPowerUpEnabled()

    hideSection = !isEnabled || !@model.get('coordinates')?
    @$('.js-location-section').toggleClass('hide', hideSection)

    if isEnabled && @model.get('coordinates')?
      @cardLocationSubview ?= @subview CardLocationView, @model
      @appendSubview @cardLocationSubview, @$('.js-card-location')
    else if @cardLocationSubview
      @cardLocationSubview.remove()
      @cardLocationSubview = null

    @

  convertToTemplate: (e) ->
    Util.stop(e)
    @model.update({ isTemplate: true })
    trackUe(Noun.CARD_TEMPLATES, Verb.SETS, Noun.IS_TEMPLATE, '', 'to template', '')
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'convertToTemplate'
      source: 'boardScreen'
      container:
        board:
          id: @model.id
        organization:
          id: @model.get('idOrganization') || ''

  convertToCard: (e) ->
    Util.stop(e)
    @model.update({ isTemplate: false })
    trackUe(Noun.CARD_TEMPLATES, Verb.SETS, Noun.IS_TEMPLATE, '', 'to card', '')

  renderBanner: ->
    if @cardTemplatesFlagEnabled
      renderComponent(React.createElement(CardBackBanner, {
        idCard: @model.id
        editable: @model.editable()
      }), @$('.js-card-banner')[0])

    @

  removeBanner: ->
    ReactDOM.unmountComponentAtNode(@$('.js-card-banner')[0])

  cardAgingSidebar: (e) ->
    Util.preventDefault(e)
    PopOver.toggle
      elem: @$('.js-card-aging-card-button')
      view: new CardAgingPopoverView({ @model })

    sendPluginUIEvent(LegacyPowerUps.cardAging, {
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'cardButton'
      objectType: 'powerUp'
      objectId: LegacyPowerUps.cardAging
      source: 'cardDetailScreen'
    })
    false
